import { ArrowUpRight } from 'lucide-react'
import { ResponsiveImage } from './ResponsiveImage'
import type { TeamMember } from '../data/site'

type TeamProfileCardProps = {
  member: TeamMember
  index: number
  isExpanded: boolean
  onOpen: () => void
  setButtonRef: (node: HTMLButtonElement | null) => void
}

export function TeamProfileCard({ member, index, isExpanded, onOpen, setButtonRef }: TeamProfileCardProps) {
  const hasPhoto = Boolean(member.image)
  const number = String(index + 1).padStart(2, '0')

  return (
    <li className={`team-profile reveal reveal--delay-${index % 3}`} itemScope itemType="https://schema.org/Person">
      <meta itemProp="worksFor" content="Diamond Salon & Spa" />
      <button
        className="team-profile-card"
        type="button"
        ref={setButtonRef}
        onClick={onOpen}
        aria-haspopup="dialog"
        aria-expanded={isExpanded}
        aria-controls="team-profile-dialog"
        aria-label={`View profile for ${member.name}, ${member.role}`}
      >
        <span className={`team-profile-card__portrait${hasPhoto ? '' : ' team-profile-card__portrait--empty'}`}>
          {hasPhoto ? (
            <ResponsiveImage
              image={member.image!}
              alt={`${member.name}, ${member.role} at Diamond Salon & Spa`}
              sizes="(max-width: 620px) 90vw, (max-width: 860px) 44vw, 28vw"
              objectFit={member.imageFit ?? 'cover'}
              objectPosition={member.imagePosition ?? '50% 30%'}
            />
          ) : (
            <span aria-hidden="true">{member.name.split(' ').map((part) => part[0]).join('')}</span>
          )}
          <span className="team-profile-card__number" aria-hidden="true">{number}</span>
        </span>
        <span className="team-profile-card__meta">
          <span className="team-profile-card__name" itemProp="name">{member.name}</span>
          <span className="team-profile-card__role" itemProp="jobTitle">{member.role}</span>
        </span>
        <span className="team-profile-card__action">View profile <ArrowUpRight aria-hidden="true" /></span>
      </button>
    </li>
  )
}
